// extracted by mini-css-extract-plugin
export default {"swatch":"swatch__EXHCY","default":"default__qfmyd","active":"active__UXIgb","md":"md__Nt1Qv default__qfmyd","sm":"sm__vPnEI default__qfmyd","has-gradient":"has-gradient__VcAqa"};